import { useState } from "react";
import useValidate from "../../hooks/useValidate";
import { useLocation } from "react-router-dom";

const Input = ({
  label,
  id,
  type,
  placeholder,
  value,
  onValueChange,
  icon,
  required,
  match,
  readonly,
  pattern,
  min
}) => {
  const [focus, setFocus] = useState(false);

  const location = useLocation();

  const attributes = {
    type: type,
    value: value,
    required: required,
    focused: focus,
    match: match,
    id: id,
    readonly: readonly,
  };

  const validate = useValidate(attributes);
  return (
    <div
      className={`relative h-16 ${
        location.pathname === "/cart/checkout" ? "" : "mt-3"
      }`}
    >
      <div className="flex items-center">
        <input
          type={type}
          pattern={pattern}
          minLength={min}
          id={id}
          placeholder={placeholder}
          readOnly={readonly}
          className={`w-full valid:border-green-500 bg-white tracking-wider outline-none pb-2 text-base text-black ease-linear border-b border-solid ${
            focus ? "border-logoRed" : "border-lightGrey"
          }`}
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          value={value}
          onChange={(e) => onValueChange(e.target.value)}
          required={required}
        />
        <div>{icon}</div>
      </div>
      <small className={`${location.pathname === "/cart/checkout" ? "hidden" : "block"} absolute left-0 bottom-0 text-xm mt-8 font-normal text-logoRed`}>
        {validate[1]}
      </small>
    </div>
  );
};

export default Input;
